import React from 'react';
import {
  getSubAgentDisplayLabel,
  isSubAgentIncomplete,
} from '../constants';
import { SUB_AGENT_TYPE_ICONS } from '../../../support/iconMappings';

function SubAgentNavChips({ subAgents, activeId, onSelect }) {
  return (
    <div className="space-y-2">
      <p className="text-xs font-medium text-content-muted">Navegar entre comportamentos</p>
      <div className="grid grid-cols-[repeat(auto-fill,minmax(10rem,1fr))] gap-2">
        {subAgents.map((subAgent, index) => {
          const Icon = SUB_AGENT_TYPE_ICONS[subAgent.type];
          const label = getSubAgentDisplayLabel(subAgent, index);
          const isActive = activeId === subAgent.id;
          const incomplete = isSubAgentIncomplete(subAgent);
          const enabled = subAgent.enabled !== false;

          return (
            <button
              key={subAgent.id}
              type="button"
              onClick={() => onSelect(subAgent.id)}
              aria-pressed={isActive}
              className={`inline-flex w-full items-center gap-2 rounded-lg border px-3 py-2 text-left transition-all duration-200 ${
                isActive
                  ? 'border-forge-300/80 bg-forge-50/70 shadow-[0_2px_8px_-4px_rgba(14,165,233,0.14)]'
                  : 'border-surface-border bg-white hover:border-slate-300 hover:bg-slate-50'
              }`}
            >
              {Icon && (
                <span
                  className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md border ${
                    isActive
                      ? 'border-forge-200 bg-forge-100 text-forge-700'
                      : 'border-surface-border bg-slate-50 text-content-muted'
                  }`}
                >
                  <Icon className="h-3.5 w-3.5" aria-hidden />
                </span>
              )}
              <span className="min-w-0 flex-1">
                <span
                  className={`block text-xs font-medium truncate ${
                    isActive ? 'text-forge-800' : 'text-content-primary'
                  }`}
                >
                  {label}
                </span>
                <span className="flex items-center gap-1.5 text-[10px] text-content-muted">
                  {!enabled ? (
                    <>
                      <span
                        className="h-1.5 w-1.5 shrink-0 rounded-full bg-amber-400"
                        aria-hidden
                      />
                      Pausado
                    </>
                  ) : incomplete ? (
                    <>
                      <span
                        className="h-1.5 w-1.5 shrink-0 rounded-full bg-amber-400"
                        aria-hidden
                      />
                      Incompleto
                    </>
                  ) : (
                    'Pronto'
                  )}
                </span>
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default SubAgentNavChips;
